/* eslint-disable jsx-a11y/alt-text */
import "./style.css";
// import eventData from "../../assets/holidays.json";
import { useEffect, useRef, useState } from "react";
import env from "../../config/env";
import { useEventData } from "../../queries/calendar";
import { useNewsfeedByAgency } from "../../queries/misc";
import { useUserInfo } from "../../context/user";
import { Helmet } from 'react-helmet';
import localforage from "localforage";

export interface HolidayEvent {
  date: string;
  title: string;
  content: string;
  country: string;
  event_categories: string;
  event_url?: string;
  hashtags?: string;
  emoji: string;
}

export interface EventData {
  holidays: HolidayEvent[];
}

export interface NewsFeedData {
  name: string,
  agency_id: any,
  description: string,
  file: string,
  createdAt: string,
}

interface EventsByDay {
  [key: string]: HolidayEvent[];
}

interface EventsByMonth {
  [key: number]: EventsByDay;
}

function Home() {
  const FACEBOOK_AUTH = env.FACEBOOK_AUTH;
  const userInfo = useUserInfo()[0];
  const checkIfGhlUser = useUserInfo()[9];
  const userActiveLocation = useUserInfo()[4];
  const agencyData = useUserInfo()[11];

  const [eventsByMonth, setEventsByMonth] = useState<EventsByMonth>({});
  const containerRef = useRef<HTMLDivElement>(null);
  const { data: eventData, isLoading: loading } = useEventData();
  const { data: newsFeed } = useNewsfeedByAgency(userInfo?.agency_id);
  const [selectedMonth, setSelectedMonth] = useState<number>(
    new Date().getMonth()
  );


  const loc_id = userActiveLocation?.id;
  const loc_name = userActiveLocation?.first_name;
  const name = userInfo?.userName;
  const email = userInfo?.email;

  const onLoad = async () => {
    if (Object.keys(userActiveLocation).length > 0) {
      if (eventData && !loading) {
        const organizedData: EventsByMonth = {};
        eventData?.holidays.forEach((event: any) => {
          const date = new Date(event.date);

          // Check if the date is valid
          if (isNaN(date.getTime())) {
            return;
          }

          const month = date.getMonth();
          const day = date.getDate().toString();

          organizedData[month] = organizedData[month] || {};
          organizedData[month][day] = organizedData[month][day] || [];
          organizedData[month][day].push(event);
        });

        setEventsByMonth(organizedData);

        setTimeout(() => {
          const specificElement = document.getElementById("focus");

          if (specificElement) {
            specificElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "nearest",
            });
          }
        }, 1000);
      }
    }
    setTimeout(() => {
      const containerElement = containerRef.current;

      // Get the specific element by ID
      const specificElement = document.getElementById("focus");

      // Check if both the container and specific element exist
      if (containerElement && specificElement) {
        specificElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }, 1000);
  };

  useEffect(() => {
    onLoad();
  }, [eventData]);

  const readableDate = (dateString: string) => {
    const date = new Date(dateString);

    // Format the date in a human-readable form
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    };

    return date.toLocaleDateString('en-US', options);
  }
 
  return (
    <div className="page-shell-wide position-relative extraPadding">
     <Helmet>
        <title>{agencyData?.Customization?.home_m_title ? agencyData?.Customization?.home_m_title : 'Your AI'}</title>
        <meta name="description"
        content={agencyData?.Customization?.home_m_description} />
        <meta
          name="description"
          content="Unlock the power of tailored AI solutions designed to save you time and boost efficiency. Quickly implement secure and transformative AI technologies to streamline business processes and achieve remarkable results from day one."
        />
         </Helmet>
      <div className="homeWrapper">
        {(newsFeed as NewsFeedData[] | undefined)?.map((item, index) => (
          <div className="feedWrapper" style={{ background: agencyData?.Customization?.newsfeed_bg ? agencyData?.Customization?.newsfeed_bg : '#fff', color: agencyData?.Customization?.newsfeed_text ? agencyData?.Customization?.newsfeed_text : '#000' }}>
            <span className="feedTags" style={{ background: agencyData?.Customization?.newsfeed_bg ? agencyData?.Customization?.newsfeed_bg : '#fff', color: agencyData?.Customization?.newsfeed_text ? agencyData?.Customization?.newsfeed_text : '#000' }}>{item?.agency_id?.name}</span>
            <h2 className="feedTitle" style={{ color: agencyData?.Customization?.newsfeed_text ? agencyData?.Customization?.newsfeed_text : '#000'}}>{item?.name}</h2>
            <h2 className="feedTitle">
              <img src={item?.file} width={"100%"} style={{ maxHeight: '500px' }} /></h2>
            <p className="feedMetaInfo" style={{ color: agencyData?.Customization?.newsfeed_text ? agencyData?.Customization?.newsfeed_text : '#000'}}>{readableDate(item?.createdAt)}</p>
            <div style={{ color: agencyData?.Customization?.newsfeed_text ? agencyData?.Customization?.newsfeed_text : '#000'}} dangerouslySetInnerHTML={{ __html: item?.description }} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Home;
